import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, tap, map} from "rxjs/operators";
  
@Injectable({providedIn: 'root'})

export class MarketingPartnerService {

  constructor(private http: HttpClient){
  }

  fetch():Observable<any[]>{
    return this.http.get<any[]>('/api/partner')
  }
 
  getById(id:string):Observable<any>{
    return this.http.get<any>(`/api/partner/${id}`)
  }



  create(): Observable<any>{
    return this.http.post<any>('/api/partner', {})
  }
  
  delete(id:string):Observable<any>{
    return this.http.delete<any>(`/api/partner/${id}`)
  }  
 

  updateName(id:string, title:string): Observable<any>{ 
    return this.http.patch<any>(`/api/partner/${id}`, {title})
  }


  updatePass(id:string, pass:string): Observable<any>{ 
    return this.http.patch<any>(`/api/partner/${id}`, {password: pass})
  }



  setPromocode(id:string, promocode:string): Observable<any>{ 
    return this.http.patch<any>(`/api/partner/${id}`, {promocode, hasPromocode:true})
  }




  clearStat(id:string): Observable<any>{ 
    return this.http.post<any>(`/api/partner/clear_stat/${id}`, {})
  }


  
  getPublishStat(id:string, hasToken:boolean, data:string): Observable<any>{ 

	 var formData = {}

	if(hasToken){
	    formData = {token:data}
	} else {
	    formData = {password:data}
	}

    return this.http.post<any>(`/api/partner/publish_stat/${id}`, formData)

  }
 



}
